import get from 'lodash/get';
import { createSelector } from 'reselect';

const configState = state => state.config;

export const getVertical = state => get(configState(state), ['vertical']);
export const getLastSearch = state => get(configState(state), ['lastSearch']);
export const getCountryCode = state => get(configState(state), ['countryCode']);
export const getVerticalId = state => get(configState(state), ['verticalId']);
export const getVerticalName = state => get(configState(state), ['verticalName']);
export const getReadingDirection = state =>
  get(configState(state), ['vertical', 'readingDirection']);
export const isPushDisallow = state => get(configState(state), ['isPushDisallow']);
export const isPermissionsBannerShow = state => get(configState(state), ['showPermissionsBanner']);
export const getShowPermissionsBannerCounter = state =>
  get(configState(state), ['showPermissionsBannerCounter']);
export const getCookieDisclaimerUrl = state =>
  get(configState(state), ['vertical', 'cookie_disclaimer_url']);

export const configSelector = createSelector(
  configState,
  config => config
);

export const getVerticalTermsUrl = createSelector(
  [getVertical],
  vertical => vertical.terms_url
);

export const getVerticalLegalUrl = createSelector(
  [getVertical],
  vertical => vertical.legal_url
);

export const getVerticalPrivacyUrl = createSelector(
  [getVertical],
  vertical => vertical.privacy_url
);

export const verticalNameSelector = createSelector(
  configSelector,
  config => config.verticalName
);

export const countryAndVerticalSelector = createSelector(
  configSelector,
  config => ({
    countryCode: config.countryCode,
    verticalName: config.verticalName,
  })
);

export const allowAutoCompleteFieldsSelector = createSelector(
  configSelector,
  config => get(config, ['vertical', 'allowAutoCompleteFieldsIn'])
);



// WEBPACK FOOTER //
// ./app/common/selectors/config.js